interface DetailFieldProps {
  label: string;
  children: React.ReactNode;
}

/** A small grey label above a value, used in the invoice details card */
export function DetailField({ label, children }: DetailFieldProps) {
  return (
    <div className={ `flex min-w-0 flex-col gap-0.5 text-[0.8125rem] text-gray-900` }>
      <span className={ `text-xs text-gray-500` }>{ label }</span>
      <div className={ `min-w-0` }>{ children }</div>
    </div>
  );
}
